<template>
  <div>
    <header class="time-of-damage-header">
      <v-col cols="12" class="header--content">
        <h1>Hasar Anında</h1>
        <!-- <h2>Talebinizden En İyi Şekilde Yararlanın</h2>
      <h2>Hak Ettiğiniz Tazminatı Alın!</h2> -->
      </v-col>
      <!-- Form alanı servis yazılana kadar kaldırıldı -->
      <!-- <make-application />-->
    </header>
  </div>
</template>

<script>
/* import makeApplication from '@/views/time-of-damage/MakeApplication' */
export default {
  components: {
    /*   makeApplication */
  }
}
</script>
